export default {
  // About Us Page
  'about.hero.subtitle': 'Nuestra Historia',
  'about.hero.title': 'Quiénes Somos',
  'about.hero.description': 'Ecosistema de 6 empresas líderes enfocado en crecimiento sostenible e innovación.',
  'about.history.title': 'Nuestra Historia',
  'about.history.p1': 'IVG CORP - Inkavida Corporation nace de la visión de crear un ecosistema empresarial integrado que genere valor sostenible en múltiples sectores de la economía. Con más de 15 años de trayectoria, hemos consolidado nuestra presencia en el mercado latinoamericano.',
  'about.history.p2': 'Desde nuestros inicios en el sector de productos naturales con Inkavida Global, hemos expandido estratégicamente nuestras operaciones hacia el retail, desarrollo inmobiliario, manufactura y servicios financieros, creando sinergias que fortalecen cada una de nuestras empresas.',
  'about.history.p3': 'Hoy, somos un referente de diversificación empresarial exitosa, con un modelo de negocio que combina solidez financiera, innovación constante y compromiso social.',
  'about.leadership.title': 'Liderazgo',
  'about.ceo.role': 'CEO & FUNDADOR',
  'about.ceo.title': 'Chief Executive Officer',
  'about.ceo.section_title': 'Nuestro CEO',
  'about.ceo.name': 'Jorge Marcacuzco',
  'about.ceo.position': 'Empresario Visionario',
  'about.ceo.description1': 'Empresario visionario con más de 15 años de experiencia en el desarrollo de ecosistemas empresariales integrados. Jorge ha liderado la transformación de IVG CORP desde sus inicios hasta convertirla en uno de los holdings más diversificados de América Latina.',
  'about.ceo.description2': 'Su enfoque estratégico en la creación de sinergias entre empresas y su visión de sostenibilidad han sido fundamentales para el crecimiento exponencial del grupo, abarcando sectores como productos naturales, retail, inmobiliaria y manufactura.',
  'about.ceo.description3': 'Bajo su liderazgo, IVG CORP ha mantenido un crecimiento sostenido, priorizando la innovación, la responsabilidad social y la creación de valor para todos los stakeholders.',
  'about.ceo.experience': 'Experiencia',
  'about.ceo.experience_years': '+15 años en gestión empresarial',
  'about.ceo.companies': 'Empresas',
  'about.ceo.companies_count': '6 empresas del grupo',
  'about.ceo.learn_more': 'Conocer más sobre Jorge Marcacuzco',
  'about.culture.collaboration': 'Colaboración',
  'about.culture.collaboration_desc': 'Trabajamos juntos para alcanzar objetivos comunes',
  'about.culture.innovation': 'Innovación',
  'about.culture.innovation_desc': 'Impulsamos la creatividad y nuevas ideas',
  'about.culture.excellence': 'Excelencia',
  'about.culture.excellence_desc': 'Buscamos la mejora continua en todo lo que hacemos',
  'about.culture.sustainability': 'Sostenibilidad',
  'about.culture.sustainability_desc': 'Comprometidos con el futuro del planeta',
  'about.mission.title': 'Misión',
  'about.mission.content': 'Crear valor sostenible a través de un ecosistema empresarial diversificado, impulsando la innovación, la excelencia operativa y el desarrollo integral de nuestros colaboradores, clientes y comunidades.',
  'about.vision.title': 'Visión',
  'about.vision.content': 'Ser el holding empresarial líder en América Latina, reconocido por nuestra capacidad de integración estratégica, innovación continua y generación de oportunidades de crecimiento sostenible en todos nuestros sectores de operación.',
  'about.values.title': 'Valores',
  'about.values.integrity': 'Integridad y transparencia',
  'about.values.operational_excellence': 'Excelencia operativa',
  'about.values.continuous_innovation': 'Innovación continua',
  'about.values.social_responsibility': 'Responsabilidad social',
  'about.values.teamwork': 'Trabajo en equipo',
  'about.culture.title': 'Cultura Corporativa',
  'about.culture.description': 'Fomentamos un ambiente de trabajo colaborativo, inclusivo y orientado al crecimiento profesional y personal de nuestros colaboradores',
  'about.strategy.title': 'Enfoque Estratégico',
  'about.strategy.description': 'Nuestra estrategia se fundamenta en pilares sólidos que guían nuestro crecimiento y expansión',
  'about.cta.title': 'Forma Parte de Nuestro Equipo',
  'about.cta.description': 'Únete a un holding empresarial en constante crecimiento y desarrollo',
  'about.cta.button': 'Contáctanos',

  // Companies Page
  'companies.hero.subtitle': 'Nuestro Ecosistema Empresarial',
  'companies.hero.title': 'Empresas del Grupo',
  'companies.hero.description': 'Seis empresas consolidadas que trabajan en sinergia para crear valor sostenible en múltiples sectores de la economía',
  'companies.megatendencias': 'Megatendencias',
  'companies.inka_drive.name': 'Inka Drive',
  'companies.inka_drive.description': 'Aplicación de transporte que conecta conductores y pasajeros, ofreciendo viajes seguros y convenientes en toda la ciudad.',
  'companies.inkavida_global.sector': 'Productos Naturales y Bienestar',
  'companies.inkavida_global.description': 'Empresa líder en productos naturales y bienestar, comprometida con la salud integral de nuestros clientes.',
  'companies.inkavida_global.service1': 'Suplementos nutricionales premium',
  'companies.inkavida_global.service2': 'Productos de bienestar natural',
  'companies.inkavida_global.service3': 'Asesoría en salud integral',
  'companies.inkavida_global.service4': 'Programas de nutrición personalizada',
  'companies.club_inkavida.sector': 'Membresías y Fidelización',
  'companies.club_inkavida.description': 'Comunidad exclusiva de membresías que ofrece beneficios únicos y programas de fidelización para nuestros socios.',
  'companies.club_inkavida.service1': 'Membresías VIP con beneficios exclusivos',
  'companies.club_inkavida.service2': 'Acceso a piscinas y áreas recreativas',
  'companies.club_inkavida.service3': 'Bungalows para relajación y descanso',
  'companies.club_inkavida.service4': 'Bar y restaurante con especialidades',
  'companies.inmobiliaria_inkavida.sector': 'Desarrollo Inmobiliario',
  'companies.inmobiliaria_inkavida.description': 'Desarrollo de lotes productivos con enfoque en agricultura sostenible, piscigranjas, turismo rural y generación de plusvalía.',
  'companies.inmobiliaria_inkavida.service1': 'Lotes productivos con alta rentabilidad',
  'companies.inmobiliaria_inkavida.service2': 'Desarrollo integral de piscigranjas',
  'companies.inmobiliaria_inkavida.service3': 'Plantaciones de alto valor agregado',
  'companies.inmobiliaria_inkavida.service4': 'Desarrollo de ecoturismo y plusvalía',
  'companies.hipermercados_inkavida.sector': 'Retail y Comercio',
  'companies.hipermercados_inkavida.description': 'Empresa especializada en alquiler y venta de locales comerciales estratégicos, con gestión integral de centros comerciales.',
  'companies.hipermercados_inkavida.service1': 'Alquiler de locales comerciales estratégicos',
  'companies.hipermercados_inkavida.service2': 'Venta de espacios comerciales premium',
  'companies.hipermercados_inkavida.service3': 'Gestión integral de centros comerciales',
  'companies.hipermercados_inkavida.service4': 'Asesoría en inversión comercial',
  'companies.inversiones_inkavida.sector': 'Servicios Financieros',
  'companies.inversiones_inkavida.description': 'Entidad financiera regulada por la SBS, especializada en captación de inversiones y préstamos con garantía hipotecaria.',
  'companies.inversiones_inkavida.service1': 'Oportunidades de inversión garantizadas',
  'companies.inversiones_inkavida.service2': 'Créditos hipotecarios con tasas competitivas',
  'companies.inversiones_inkavida.service3': 'Evaluación de riesgo especializada',
  'companies.inversiones_inkavida.service4': 'Regulación y supervisión SBS',
  'companies.inka_drive.sector': 'Tecnología y Transporte',
  'companies.inka_drive.service1': 'Servicio de transporte urbano 24/7',
  'companies.inka_drive.service2': 'Conductores verificados y capacitados',
  'companies.inka_drive.service3': 'Tarifas competitivas y transparentes',
  'companies.inka_drive.service4': 'Seguimiento en tiempo real de viajes',
  'companies.visit_button': 'Visitar',
  'companies.sectors.natural': 'Productos Naturales y Bienestar',
  'companies.sectors.membership': 'Membresías y Fidelización',
  'companies.sectors.realestate': 'Desarrollo Inmobiliario',
  'companies.sectors.retail': 'Retail y Comercio',
  'companies.sectors.financial': 'Servicios Financieros',
  'companies.sectors.manufacturing': 'Manufactura y Producción',
  'companies.services.title': 'Servicios Principales:',
  'companies.integration.title': 'Integración Estratégica',
  'companies.integration.description': 'Nuestras empresas trabajan de manera coordinada, creando sinergias que potencian el valor de cada operación',
  'companies.integration.value_chain.title': 'Cadena de Valor',
  'companies.integration.value_chain.description': 'Desde la manufactura hasta el punto de venta, controlamos toda la cadena de valor para garantizar calidad y eficiencia.',
  'companies.integration.customer_base.title': 'Base de Clientes',
  'companies.integration.customer_base.description': 'Compartimos una base de clientes leales que se benefician de productos y servicios complementarios.',
  'companies.integration.innovation.title': 'Innovación Compartida',
  'companies.integration.innovation.description': 'Las mejores prácticas e innovaciones se replican en todo el grupo, acelerando el crecimiento.',
  'companies.cta.title': '¿Interesado en Colaborar?',
  'companies.cta.description': 'Explora oportunidades de negocio con nuestras empresas',
  'companies.cta.button': 'Contactar Ahora',

  // Contact Page
  'contact.hero.subtitle': 'Estamos Aquí Para Ti',
  'contact.hero.title': 'Soporte',
  'contact.hero.description': 'Conecta con nosotros y descubre cómo podemos trabajar juntos',
  'contact.info.title': 'Información de Soporte',
  'contact.info.description': 'Nuestro equipo está listo para atender tus consultas y explorar oportunidades de colaboración con el ecosistema IVG.',
  'contact.office.title': 'Oficina Principal',
  'contact.office.address': 'Mz.16, Lt.5, Villa de Jesús. Villa el Salvador, Lima, Perú',
  'contact.office.reference': 'Ref. Costado del Mercado Unicachi o Mega Plaza Villa el Salvador',
  'contact.email.title': 'Email',
  'contact.email.address': 'soporte@ivgcorp.com',
  'contact.phone.title': 'Celular',
  'contact.phone.number': '(+51) 977 856 356',
  'contact.phone2.title': 'Central Telefónica',
  'contact.phone2.number': '(01) 701 7676',
  'contact.hours.title': 'Horario de Atención',
  'contact.hours.weekdays': 'Lunes a Sábado: 9:00 AM - 6:00 PM',
  'contact.hours.sunday': 'Domingo: Cerrado',
  'contact.jobs.title': '¿Buscas Trabajo?',
  'contact.jobs.description': 'Envía tu CV y únete a nuestro equipo corporativo',
  'contact.jobs.button': 'Oportunidades Laborales',
  'contact.form.name_placeholder': 'Tu nombre completo',
  'contact.form.email_placeholder': 'tu@email.com',
  'contact.form.phone_placeholder': '+51 XXX XXX XXX',
  'contact.form.company_select': 'Selecciona una empresa',
  'contact.form.company_other': 'Otra empresa',
  'contact.form.subject_select': 'Selecciona un asunto',
  'contact.form.subject_general': 'Consulta General',
  'contact.form.subject_business': 'Oportunidades de Negocio',
  'contact.form.subject_investments': 'Inversiones',
  'contact.form.subject_suppliers': 'Proveedores',
  'contact.form.subject_hr': 'Recursos Humanos',
  'contact.form.subject_other': 'Otro',
  'contact.form.message_placeholder': 'Cuéntanos cómo podemos ayudarte...',
  'contact.form.character_limit': 'Máximo 500 caracteres',
  'contact.map.title': 'Nuestra Ubicación',
  'contact.map.description': 'Visítanos en nuestras oficinas en Villa el Salvador',
  'contact.business.title': '¿Buscas Oportunidades de Negocio?',
  'contact.business.description': 'Si estás interesado en colaborar con alguna de nuestras empresas o explorar oportunidades de inversión, nuestro equipo de desarrollo de negocios está listo para atenderte.',
  'contact.form.title': 'Envíanos un Mensaje',
  'contact.form.name': 'Nombre Completo',
  'contact.form.email': 'Email',
  'contact.form.phone': 'Teléfono',
  'contact.form.company': 'Empresa',
  'contact.form.subject': 'Asunto',
  'contact.form.message': 'Mensaje',
  'contact.form.submit': 'Enviar Mensaje',
  'contact.form.sending': 'Enviando...',
  'contact.form.success': '¡Mensaje enviado exitosamente! Nos pondremos en contacto contigo pronto.',
  'contact.form.error': 'Hubo un error al enviar el mensaje. Por favor, intenta nuevamente.',

  // Gallery Page
  'gallery.hero.subtitle': 'Multimedia Corporativa',
  'gallery.hero.title': 'Galería IVG CORP',
  'gallery.hero.description': 'Descubre nuestras instalaciones, eventos corporativos y el equipo que impulsa el crecimiento del grupo empresarial',
  'gallery.filters.all': 'Todos',
  'gallery.filters.facilities': 'Instalaciones',
  'gallery.filters.events': 'Eventos',
  'gallery.filters.team': 'Equipo',
  'gallery.filters.projects': 'Proyectos',
  'gallery.modal.close': 'Cerrar',
  'gallery.modal.more_info': 'Más Información',

  // News Page
  'news.hero.subtitle': 'Actualidad Corporativa',
  'news.hero.title': 'Noticias y Comunicados',
  'news.hero.description': 'Mantente informado sobre las últimas novedades, expansiones y logros del grupo empresarial',
  'news.read_more': 'Leer más',
  'news.modal.close': 'Cerrar',
  'news.modal.more_info': 'Más Información',
  'news.newsletter.title': 'Suscríbete a Nuestro Newsletter',
  'news.newsletter.description': 'Recibe las últimas noticias y actualizaciones del grupo empresarial directamente en tu correo',
  'news.newsletter.placeholder': 'Tu correo electrónico',
  'news.newsletter.button': 'Suscribirse',

  // Careers Page
  'careers.hero.subtitle': 'Únete a Nuestro Equipo',
  'careers.hero.title': 'Oportunidades Laborales',
  'careers.hero.description': 'En IVG CORP buscamos talento excepcional que comparta nuestra visión de excelencia e innovación. Envíanos tu CV y nuestro equipo lo analizará para futuras oportunidades.',
  'careers.benefits.title': '¿Por qué trabajar en IVG CORP?',
  'careers.benefits.subtitle': 'Ofrecemos un ambiente de trabajo dinámico con oportunidades de crecimiento profesional',
  'careers.benefits.growth.title': 'Crecimiento Profesional',
  'careers.benefits.growth.description': 'Desarrollo y capacitación continua',
  'careers.benefits.collaborative.title': 'Ambiente Colaborativo',
  'careers.benefits.collaborative.description': 'Trabajo en equipo e innovación',
  'careers.benefits.competitive.title': 'Beneficios Competitivos',
  'careers.benefits.competitive.description': 'Compensación y beneficios exclusivos',
  'careers.benefits.international.title': 'Proyección Internacional',
  'careers.benefits.international.description': 'Proyectos multinacionales',
  'careers.benefits.innovation.title': 'Innovación',
  'careers.benefits.innovation.description': 'Creatividad e ideas nuevas',
  'careers.benefits.stability.title': 'Estabilidad',
  'careers.benefits.stability.description': 'Grupo sólido con 7+ años',
  'careers.form.title': 'Oportunidades Laborales',
  'careers.form.subtitle': 'Completa el formulario y adjunta tu currículum. Nuestro equipo de recursos humanos lo revisará y te contactaremos si tu perfil se ajusta a nuestras necesidades.',
  'careers.form.name': 'Nombre Completo',
  'careers.form.name_placeholder': 'Tu nombre completo',
  'careers.form.email': 'Correo Electrónico',
  'careers.form.email_placeholder': 'tu@email.com',
  'careers.form.phone': 'Teléfono',
  'careers.form.phone_placeholder': '+51 999 999 999',
  'careers.form.area': 'Área de Interés',
  'careers.form.area_placeholder': 'Selecciona un área',
  'careers.form.area_administration': 'Administración',
  'careers.form.area_finance': 'Finanzas',
  'careers.form.area_marketing': 'Marketing',
  'careers.form.area_sales': 'Ventas',
  'careers.form.area_operations': 'Operaciones',
  'careers.form.area_hr': 'Recursos Humanos',
  'careers.form.area_technology': 'Tecnología',
  'careers.form.area_logistics': 'Logística',
  'careers.form.area_legal': 'Legal',
  'careers.form.area_other': 'Otro',
  'careers.form.cv_label': 'Adjuntar CV (PDF, DOC, DOCX) *',
  'careers.form.cv_selected': 'Archivo seleccionado:',
  'careers.form.cv_requirements': 'Máximo 5MB. Formatos: PDF, DOC, DOCX',
  'careers.form.cv_error_type': 'Solo se permiten archivos PDF, DOC o DOCX',
  'careers.form.cv_error_size': 'El archivo no puede ser mayor a 5MB',
  'careers.form.message': 'Mensaje / Presentación',
  'careers.form.message_placeholder': 'Cuéntanos brevemente sobre tu experiencia y por qué te gustaría trabajar en IVG CORP (máximo 500 caracteres)',
  'careers.form.characters': 'caracteres',
  'careers.form.submit': 'Enviar Postulación',
  'careers.form.submitting': 'Enviando...',
  'careers.form.success': '¡Gracias por tu postulación! Hemos recibido tu CV y lo revisaremos pronto.',
  'careers.form.error': 'Hubo un error al enviar tu postulación. Por favor, intenta nuevamente.',
  'careers.form.privacy': 'Al enviar tu postulación, aceptas que IVG CORP procese tus datos personales para fines de reclutamiento.',
  'careers.stats.employees': 'Colaboradores',
  'careers.stats.companies': 'Empresas del Grupo',
  'careers.stats.offices': 'Oficinas',
  'careers.stats.countries': 'Países',

  // Locations Page
  'locations.hero.subtitle': 'Presencia Global',
  'locations.hero.title': 'Nuestras Ubicaciones',
  'locations.hero.description': 'Presencia estratégica en los principales mercados de América Latina con operaciones en múltiples países',
  'locations.expansion.title': 'Expansión Regional',
  'locations.expansion.subtitle': 'Operaciones en 3 países con planes de expansión continua',
  'locations.stats.offices': 'Oficinas y Centros',
  'locations.stats.countries': 'Países',
  'locations.stats.cities': 'Ciudades',
  'locations.filters.all': 'Todos los Países',
  'locations.filters.peru': 'Perú',
  'locations.filters.chile': 'Chile',
  'locations.filters.colombia': 'Colombia',
  'locations.headquarters': 'Sede Principal',
  'locations.all_locations': 'Todas las Ubicaciones',
  'locations.contact_info.address': 'Dirección',
  'locations.contact_info.phone': 'Teléfono',
  'locations.contact_info.email': 'Email',
  'locations.contact_info.hours': 'Horario',
  'locations.companies_here': 'Empresas en esta ubicación:',
  'locations.companies_label': 'Empresas:',
  'locations.cta.title': '¿Necesitas Más Información?',
  'locations.cta.description': 'Contáctanos para conocer más sobre nuestras ubicaciones y servicios',
  'locations.cta.button': 'Contactar',

  // FAQ Page
  'faq.hero.subtitle': 'Centro de Ayuda',
  'faq.hero.title': 'Preguntas Frecuentes',
  'faq.hero.description': 'Encuentra respuestas a las preguntas más comunes sobre IVG CORP y nuestras empresas',
  'faq.categories.general': 'General',
  'faq.categories.companies': 'Empresas del Grupo',
  'faq.categories.investments': 'Inversiones y Alianzas',
  'faq.categories.employment': 'Empleo y Carreras',
  'faq.categories.sustainability': 'Sostenibilidad',
  'faq.general.q1': '¿Qué es IVG CORP?',
  'faq.general.a1': 'IVG CORP (Inkavida Corporation) es un holding empresarial multinacional que agrupa a seis empresas líderes en diferentes sectores: productos naturales, membresías, desarrollo inmobiliario, retail, inversiones y tecnología de transporte. Nuestro objetivo es crear sinergias entre las empresas del grupo para ofrecer soluciones integrales y generar valor sostenible.',
  'faq.general.q2': '¿Cuál es la visión del grupo empresarial?',
  'faq.general.a2': 'Nuestra visión es ser el holding empresarial líder en América Latina, reconocido por la excelencia operativa, innovación constante y compromiso con el desarrollo sostenible. Buscamos crear un ecosistema empresarial integrado que genere valor para nuestros clientes, colaboradores y comunidades.',
  'faq.companies.q1': '¿Cuáles son las empresas que conforman IVG CORP?',
  'faq.companies.a1': 'El grupo está conformado por seis empresas:',
  'faq.companies.list1': 'Inkavida Global (productos naturales y bienestar)',
  'faq.companies.list2': 'Club Inkavida (membresías y beneficios)',
  'faq.companies.list3': 'Inmobiliaria Inkavida (desarrollo inmobiliario)',
  'faq.companies.list4': 'Hipermercados Inkavida (retail)',
  'faq.companies.list5': 'Inversiones Inkavida (servicios financieros)',
  'faq.companies.list6': 'Inka Drive (tecnología de transporte)',
  'faq.companies.q2': '¿Cómo puedo contactar a una empresa específica del grupo?',
  'faq.companies.a2': 'Cada empresa tiene sus propios canales de contacto. Puedes visitar nuestra sección de Empresas del Grupo para encontrar información específica de contacto, o utilizar nuestro formulario general y te dirigiremos al área correspondiente.',
  'faq.companies.q3': '¿Las empresas del grupo trabajan de forma independiente?',
  'faq.companies.a3': 'Si bien cada empresa mantiene su autonomía operativa y especialización, trabajamos de forma integrada para crear sinergias y ofrecer soluciones complementarias. Esta estructura nos permite aprovechar las fortalezas de cada empresa mientras mantenemos la agilidad y enfoque en cada sector.',
  'faq.investments.q1': '¿Cómo puedo invertir en IVG CORP?',
  'faq.investments.a1': 'Ofrecemos diferentes oportunidades de inversión según el perfil del inversionista. Para información detallada sobre oportunidades actuales, requisitos y procesos, te invitamos a contactar directamente a Inversiones Inkavida a través de nuestro formulario de contacto o enviando un correo a inversiones@ivgcorp.com.',
  'faq.investments.q2': '¿IVG CORP busca alianzas estratégicas?',
  'faq.investments.a2': 'Sí, estamos constantemente evaluando alianzas estratégicas que agreguen valor a nuestro ecosistema empresarial. Si tienes una propuesta de colaboración o alianza, puedes contactarnos a través de alianzas@ivgcorp.com con los detalles de tu propuesta.',
  'faq.employment.q1': '¿Cómo puedo trabajar en IVG CORP?',
  'faq.employment.a1': 'Puedes enviar tu CV a través de la sección de Contacto de nuestro sitio web, donde encontrarás el botón "Oportunidades Laborales". Envía tu CV y nuestro equipo de recursos humanos lo evaluará para posiciones actuales o futuras. Si tu perfil coincide con nuestras necesidades, nos pondremos en contacto contigo.',
  'faq.employment.q2': '¿Qué beneficios ofrecen a los empleados?',
  'faq.employment.a2': 'Ofrecemos un paquete integral de beneficios que incluye: seguro de salud premium para el empleado, programas de desarrollo profesional y capacitación continua, flexibilidad laboral, bonos por desempeño, ambiente colaborativo, y programas de reconocimiento y crecimiento de carrera.',
  'faq.employment.q3': '¿Qué oportunidades de crecimiento profesional ofrecen?',
  'faq.employment.a3': 'En IVG CORP valoramos el desarrollo de nuestros colaboradores. Ofrecemos programas de capacitación continua, mentoring, oportunidades de promoción interna y la posibilidad de trabajar en diferentes áreas de nuestras empresas para ampliar la experiencia profesional.',
  'faq.sustainability.q1': '¿Qué iniciativas de responsabilidad social tiene IVG CORP?',
  'faq.sustainability.a1': 'Como empresa comprometida con nuestra comunidad, desarrollamos iniciativas de responsabilidad social de manera selectiva, enfocándonos en proyectos de impacto real en educación y desarrollo comunitario. Aunque no son programas masivos, buscamos generar un cambio significativo en las comunidades donde operamos.',
  'faq.sustainability.q2': '¿Cómo contribuye el grupo al desarrollo sostenible?',
  'faq.sustainability.a2': 'Buscamos integrar prácticas sostenibles en nuestras operaciones cuando es posible, promoviendo productos naturales y adoptando medidas de eficiencia en nuestros procesos. Aunque no tenemos programas extensivos, nos esforzamos por operar de manera responsable con el medio ambiente.',
  'faq.sustainability.q3': '¿Qué medidas de calidad implementan en sus productos?',
  'faq.sustainability.a3': 'Mantenemos estándares de calidad en todos nuestros productos y servicios. Cada empresa del grupo implementa controles de calidad apropiados para su sector, asegurando que nuestros clientes reciban productos y servicios confiables que cumplan con sus expectativas.',
  'faq.cta.title': '¿No Encontraste tu Respuesta?',
  'faq.cta.description': 'Nuestro equipo está listo para ayudarte con cualquier consulta adicional',
  'faq.cta.button': 'Contáctanos',

  // Opportunity Page
  'opportunity.hero.subtitle': 'Modelo de Negocio',
  'opportunity.hero.title': 'Tu Oportunidad de Éxito',
  'opportunity.hero.description': 'Únete a nuestro modelo de negocio multinivel y construye tu libertad financiera con el respaldo de IVG CORP',
  'opportunity.system.title': 'Cómo Funciona el Sistema',
  'opportunity.system.description': 'Un modelo simple y transparente que te permite generar ingresos mientras ayudas a otros a alcanzar sus metas',
  'opportunity.step1.title': 'Regístrate',
  'opportunity.step1.description': 'Únete a nuestra red con una inversión inicial mínima y accede a todos los productos y herramientas de capacitación',
  'opportunity.step2.title': 'Construye tu Red',
  'opportunity.step2.description': 'Invita a otros emprendedores a unirse y forma tu equipo. Cada persona que sumes fortalece tu red de ingresos',
  'opportunity.step3.title': 'Genera Ingresos',
  'opportunity.step3.description': 'Recibe comisiones por ventas directas y bonos residuales por el crecimiento de tu red de distribuidores',
  'opportunity.brochure.title': 'Brochure Digital',
  'opportunity.brochure.description': 'Explora nuestro catálogo completo con información detallada sobre productos, planes y oportunidades',
  'opportunity.brochure.catalog_description': 'Explora nuestro catálogo completo de productos y oportunidades de negocio',
  'opportunity.brochure.download': 'Descargar PDF',
  'opportunity.testimonials.title': 'Testimonios de Socios',
  'opportunity.testimonials.description': 'Conoce las historias de éxito de quienes ya forman parte de nuestra red',
  'opportunity.testimonials.level': 'Networker Profesional',
  'opportunity.testimonials.achievements': 'Logros Destacados',
  'opportunity.testimonial1.name': 'Zulema Carrillo',
  'opportunity.testimonial1.text': 'Como mujer emprendedora, IVG CORP me dio la oportunidad de brillar. Logré un estilo de vida que supera mis expectativas. ¡Es posible!',
  'opportunity.testimonial1.achievements': 'Independencia total, Estilo de vida soñado, Realización personal',
  'opportunity.testimonial2.name': 'Russel Montalvo',
  'opportunity.testimonial2.text': 'El sistema de IVG CORP es extraordinario. En 3 años y medio logré un nivel de vida excepcional. Ahora ayudo a otros a alcanzar sus sueños.',
  'opportunity.testimonial2.achievements': 'Inversiones exitosas, Calidad de vida superior, Libertad de tiempo',
  'opportunity.testimonial3.name': 'Jhonny Ruiz',
  'opportunity.testimonial3.text': 'Desde que alcancé el nivel Diamante, mi vida cambió radicalmente. Tengo un estilo de vida que antes solo imaginaba. La clave es la constancia.',
  'opportunity.testimonial3.achievements': 'Viajes internacionales, Estilo de vida premium, Independencia total',
  'opportunity.testimonial4.name': 'Israel Grijalva',
  'opportunity.testimonial4.text': 'Gracias a IVG CORP logré mi libertad financiera total. En 1 año mi estilo de vida cambió completamente. Este negocio transformó mi realidad.',
  'opportunity.testimonial4.achievements': 'Libertad financiera, Viajes de lujo',
  'opportunity.cta.title': '¿Listo para Comenzar?',
  'opportunity.cta.description': 'Únete a miles de emprendedores que ya están construyendo su libertad financiera con IVG CORP',
  'opportunity.cta.button': 'Más Información',
};